// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4761":"19bb33c49f38886e","6123":"19bb33c49f38886e"}[chunkId] + ".css";
};